export const PRO_PLAN_DAUS = 450;
export const PRO_PLAN_PRICE = 399;
